import React, { ChangeEvent } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Slider,
  createTheme,
  useMediaQuery,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";

interface Filtro {
  cantidad: number;
  startDate: string;
  endDate: string;
  visto: string;
}

interface FilterModalProps {
  open: boolean;
  onClose: () => void;
  onFilterChange: (
    value: string | number, 
    type: string
  ) => void;
  filtro: Filtro;
}

const FilterModal: React.FC<FilterModalProps> = ({ open, onClose, onFilterChange, filtro }) => {
  const handleSliderChange = (_event: Event, newValue: number | number[]) => {
    onFilterChange(newValue as number, "cantidad");
  };

  const handleTextFieldChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, type: string) => {
    onFilterChange(e.target.value, type);
  };

  const handleSelectChange = (e: SelectChangeEvent<string>, type: string) => {
    onFilterChange(e.target.value, type);
  };

  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // Obtener la cantidad máxima de protocolos del local storage
  const maxProtocolos = localStorage.getItem('protocolos');
  const maxCantidad = maxProtocolos ? JSON.parse(maxProtocolos).length : 0;

  // Crear marcas para el slider
  const marks = [
    { value: 0, label: '0' },
    { value: maxCantidad, label: 'Máx' }, // Marca para el valor máximo
  ];

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isSmallScreen ? "80%" : 400,
          maxWidth: 600,
          bgcolor: "background.paper",
          p: 4,
          boxShadow: 24,
          borderRadius: 3,
          overflow: "auto",
          maxHeight: "90vh",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "column",
            gap: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Filtros
          </Typography>
          <Divider />
          <Typography variant="body1" gutterBottom>
            Cantidad de protocolos
          </Typography>
          <Slider
            value={filtro.cantidad}
            onChange={handleSliderChange}
            aria-labelledby="cantidad-slider"
            valueLabelDisplay="on" // Muestra el valor actual
            step={1}
            marks={marks} // Usa las marcas definidas
            min={0}
            max={maxCantidad} // Utiliza maxCantidad como el valor máximo
          />
          <Divider />
          <Typography variant="body1" gutterBottom>
            Rango de fechas a buscar
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: 2,
              mb: 2,
            }}
          >
            <TextField
              label="Inicio"
              type="date"
              value={filtro.startDate}
              onChange={(e) => handleTextFieldChange(e, "startDate")}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: isSmallScreen ? "100%" : "48%" }}
            />
            <TextField
              label="Fin"
              type="date"
              value={filtro.endDate}
              onChange={(e) => handleTextFieldChange(e, "endDate")}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: isSmallScreen ? "100%" : "48%" }}
            />
          </Box>
          <Divider />
          <Typography variant="body1" gutterBottom>
            Visto
          </Typography>
          <Select
            value={filtro.visto}
            onChange={(e) => handleSelectChange(e, "visto")}
            fullWidth
            sx={{ mb: 2 }}
          >
            <MenuItem value="all">Todos</MenuItem>
            <MenuItem value="visto">Vistos</MenuItem>
            <MenuItem value="noVisto">No Vistos</MenuItem>
          </Select>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose} variant="contained">
            Aplicar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterModal;
